export const productConnectionFragment = /* GraphQL */ `
	fragment productConnection on ProductConnection {
		pageInfo {
			hasNextPage
			hasPreviousPage
			endCursor
		}
		edges {
			node {
				id
				title
				vendor
				handle
				priceRange {
					minVariantPrice {
						amount
						currencyCode
					}
				}
				images(first: 1) {
					pageInfo {
						hasNextPage
						hasPreviousPage
					}
					edges {
						node {
							id
							originalSrc
							altText
							width
							height
						}
					}
				}
			}
		}
	}
`

const getAllProductsQuery = /* GraphQL */ `
	query getAllProducts(
		$first: Int = 250
		$query: String = ""
		$sortKey: ProductSortKeys = RELEVANCE
		$reverse: Boolean = false
	) {
		products(first: $first, sortKey: $sortKey, reverse: $reverse, query: $query) {
			...productConnection
		}
	}

	${productConnectionFragment}
`
export default getAllProductsQuery
